var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.86304V14.2073C0 14.2073 3.54662 14.0679 7.675 16.21C11.8034 14.0679 15.35 14.2073 15.35 14.2073V4.86304C15.35 4.86304 11.1641 4.86304 7.675 6.86578C4.18595 4.86304 0 4.86304 0 4.86304Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67506 4.863C8.94669 4.863 9.97756 3.77438 9.97756 2.4315C9.97756 1.08862 8.94669 0 7.67506 0C6.40342 0 5.37256 1.08862 5.37256 2.4315C5.37256 3.77438 6.40342 4.863 7.67506 4.863Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle2);
export default __webpack_public_path__ + "static/media/circle2.47e1a0eabbf6e41bed13a1a418049434.svg";
export { ForwardRef as ReactComponent };